import Delta from 'quill-delta';

import QuillField from 'packages/kakapo-ui-kit/components/editors/QuillField';

export default function OpenQuestionInput(props: { name: string; autoFocus?: boolean }) {
	return (
		<QuillField
			name={`${props.name}.openQuestion`}
			wide
			boxedStyling
			theme="snow"
			autoFocus={props.autoFocus}
		/>
	);
}
